import { createFileRoute } from '@tanstack/react-router';
import ReviewPage from '@/features/resume-builder/review';

/** EU-762 RN-18..25 — "Revise suas informações" (substitui o índice provisório da EU-761). */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/revisar')({
  component: ReviewPage,
});
